import { useEffect, useRef } from 'react';

export function installationAutomaticReadDue(at?: number | null) {
  if (at === undefined || at === null) return true;
  const age = Date.now() - at;
  return age < 0 || age >= 30000;
}

/** Schedule status reads only; callers retain their own request and permission guards. */
export function useVisibleInstallationRefresh(scope: unknown, refresh: () => void) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    if (!scope) return;
    let active = true;
    const check = () => {
      if (active && document.visibilityState !== 'hidden') latest.current();
    };
    const timer = window.setInterval(check, 5 * 60 * 1000);
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, [scope]);
}

export function boundedInstallationRead<T>(request: Promise<T>, controller: AbortController): Promise<T> {
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (complete: () => void) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      controller.signal.removeEventListener('abort', canceled);
      complete();
    };
    const canceled = () => finish(() => reject(new Error('Installation status read stopped')));
    const timer = window.setTimeout(() => controller.abort(), 30000);
    controller.signal.addEventListener('abort', canceled, { once: true });
    if (controller.signal.aborted) canceled();
    request.then(result => finish(() => resolve(result)), error => finish(() => reject(error)));
  });
}
